import { ManagementReportAccountingExecutionRepository } from '@domain/management-report-accounting-execution/repositories/management-report-accounting-execution.repository';
import { ManagementReportAccountingExecutionRepositoryService } from '../repositories/management-report-accounting-execution.service';

export const ManagementReportAccountingExecutionProvider = [
  {
    provide: ManagementReportAccountingExecutionRepository,
    useClass: ManagementReportAccountingExecutionRepositoryService,
  },
];
